import React from "react";
import ServiceBanner from "../components/Services/ServiceBanner";
import OurSevicesList from "../components/Services/OurSevicesList";
import Testimonials from "../components/home/Testimonials";
import HomeProcess from "../components/home/HomeProcess";



const Servicespage = () => {
  return (
    <>
<ServiceBanner/>
<OurSevicesList/>
<Testimonials/>
<HomeProcess/>
    </>
  );
};

export default Servicespage;
